<template>
  <v-chip
    :small="small"
    outlined
    :color="statusMap('color')"
  >
    <v-icon
      v-if="statusMap('icon')"
      :small="small"
      left
    >
      {{ statusMap('icon') }}
    </v-icon>

    {{ statusMap('label') }}
  </v-chip>
</template>
<script>
import moment from 'moment'
import { isNumber, get, isEmpty } from 'lodash'

export default {
  props: {
    invoice: {
      type: Object,
      default: () => ({})
    },
    small: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getIcon() {
      if (this.isScheduled()) {
        return 'access_time'
      } else {
        return false
      }
    },
    isFailed() {
      return !isEmpty(get(this.invoice, 'payment_intent.last_payment_error'))
    },
    isScheduled() {
      // An invoice is schedule if
      return this.invoice.auto_advance === true
        && this.invoice.billing_reason === 'subscription_cycle'
        && this.invoice.subscription
    },
    isPastDue() {
      const dueDate = this.invoice.due_date
      const now = moment().unix()

      // dueDate will be null for drafts (or maybe undefined in other cases)
      return isNumber(dueDate) && this.invoice.status === 'open'
        ? dueDate < now
        : false
    },
    isDraft() {
      return this.invoice.status === 'draft'
    },
    isCart() {
      // Metadata is stored as string key/value pairs
      return get(this.invoice, 'metadata.isCart') === 'true'
    },
    statusMap(type) {
      const { status } = this.invoice || {}
      const statusMap = {
        paid: {
          color: 'success',
          label: 'Paid'
        },
        draft: {
          color: 'grey',
          label: 'Draft'
        },
        past_due: {
          color: 'warning',
          label: 'Past due'
        },
        scheduled: {
          color: 'grey',
          label: 'Scheduled',
          icon: 'access_time'
        },
        void: {
          color: 'grey',
          label: 'Void'
        },
        open: {
          color: 'blue',
          label: 'Open'
        },
        failed: {
          color: 'error',
          label: 'Failed'
        },
        uncollectible: {
          color: 'grey',
          label: 'Uncollectible'
        }
      }

      if (this.isFailed()) {
        return statusMap.failed[type]
      } else if (this.isScheduled()) {
        return statusMap.scheduled[type]
      } else if (this.isPastDue()) {
        return statusMap.past_due[type]
      } else if(this.isCart() && type === 'icon') {
        // Specific use case
        return 'shopping_cart'
      } else if (status in statusMap) {
        return statusMap[ status ][ type ]
      } else {
        // fallback value
        return type === 'color'
          ? 'grey'
          : status
      }
    },
  }
}
</script>
